"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToShare = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _logger = require("../../logger");
var _createErrorExportHtml = require("../../utils/createErrorExportHtml");
var _createErrorExportText = require("../../utils/createErrorExportText");
var _styled = require("../ErrorButton/styled");
var _getOperationTrackingLink = require("../OperationId/getOperationTrackingLink");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('CopyToShare');
const CopyToShare = ({
  text = 'Copy To Share',
  data
}) => {
  const [savedToClipBoard, setSavedToClipBoard] = (0, _react.useState)(false);
  const fullData = (0, _react.useMemo)(() => {
    const {
      operationResourceId,
      ...rawData
    } = data;
    return {
      ...rawData,
      url: window.location.href,
      occurredAt: new Date().toUTCString(),
      // The time is captured here to represent the moment when the page was rendered (not copied)
      operationTraceLink: data.operationId != null && operationResourceId ? (0, _getOperationTrackingLink.getOperationTrackingLink)({
        operationId: data.operationId,
        operationResourceId
      }) : undefined
    };
  }, [data]);
  const handleCopy = (0, _react.useCallback)(async () => {
    if (typeof navigator.clipboard.write === 'function') {
      try {
        const clipboardItem = new ClipboardItem({
          'text/html': (0, _createErrorExportHtml.createErrorExportHtml)(fullData),
          'text/plain': (0, _createErrorExportText.createErrorExportText)(fullData)
        });
        await navigator.clipboard.write([clipboardItem]);
        setSavedToClipBoard(true);
        setTimeout(() => setSavedToClipBoard(false), 1500);
      } catch (error) {
        logger.error(new Error('Failed to copy to clipboard', {
          cause: error
        }));
      }
    }
  }, [fullData]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box
  // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
  , {
    sx: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      title: savedToClipBoard ? 'Copied!' : 'Copy to clipboard',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.StyledButton, {
        id: "ui-error-page-back-button",
        variant: "contained",
        color: "primary",
        onClick: handleCopy,
        children: [savedToClipBoard ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {
          fontSize: "small"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Share, {
          fontSize: "small"
        }), " ", text]
      })
    })
  });
};
exports.CopyToShare = CopyToShare;
